import './styles.scoped.css'
import {Outlet} from 'react-router-dom'
import {Header, Sidebar} from '../../components'
import {useMobile} from '../../hooks'

export default () => {
    const {mobile} = useMobile()

    return (
        <>
            {mobile ? (
                <Sidebar />
            ) : (
                <>
                    <Header />
                    <Sidebar />
                </>
            )}
            <div className="container">
                <div className="page">
                    <Outlet />
                </div>
            </div>
        </>
    )
}
